import { createFileRoute } from '@tanstack/react-router';

import { LoadingScreen } from '@/components/loading-screen';
import { FieldGroupsPage } from '@/features/GroundTruthHub/FieldGroups/FieldGroupsPage';
import { GroundTruthNoAccess } from '@/features/GroundTruthHub/GroundTruthNoAccess';
import { useGroundTruthGuard } from '@/features/GroundTruthHub/useGroundTruthGuard';
import { groundTruthRouteBoundaries } from '@/features/GroundTruthHub/GroundTruthNotFound';

function GroundTruthFieldsPage() {
    const { isLoading, canAccess } = useGroundTruthGuard();

    if (isLoading) return <LoadingScreen />;
    if (!canAccess) return <GroundTruthNoAccess />;

    return <FieldGroupsPage />;
}

export const Route = createFileRoute('/ground-truth/fields')({
    ...groundTruthRouteBoundaries,
    component: GroundTruthFieldsPage,
});
